"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.isEmailFormatValid = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
exports.isPhoneFormatValid = (phone) => {
    const re = /^(\({1}\d{3}\){1}[\s]\d{3}[-]\d{4})$|^(\d{3}[\s]\d{3}[\s]\d{4})$|^(\d{3}[-]\d{3}[-]\d{4})$|^(\d{3}\d{3}\d{4})$/;
    return re.test(phone);
};
exports.isWebsiteFormatValid = (website) => {
    const re = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    return re.test(website);
};
exports.hasLowercase = (string) => {
    const re = /^.*[a-z]/;
    return re.test(string);
};
exports.hasUppercase = (string) => {
    const re = /^.*[A-Z]/;
    return re.test(string);
};
exports.isNumericString = (string) => {
    const re = /^[0-9]*$/;
    return re.test(string);
};
exports.isAlphabet = (string) => {
    const re = /^[a-zA-Z]+$/;
    return re.test(string);
};
exports.isNumericStringWithSpace = (string) => {
    const re = /^[0-9 ]*$/;
    return re.test(string);
};
exports.isAlphaSpaceString = (string) => {
    const re = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
    return re.test(string);
};
exports.hasNumericChar = (string) => {
    const re = /^.*[0-9]/;
    return re.test(string);
};
exports.hasSpecialChar = (string) => {
    const re = /["!#$%&’()*+,-./\\:;<=>?@[\]\^_`{|}~]/;
    return re.test(string);
};
exports.hasAlphaChar = (string) => {
    const re = /^.*[a-zA-Z]/;
    return re.test(string);
};
exports.hasSpecialCharForPhone = (string) => {
    const re = /[!@#$%^&*`~()_\=\[\]{};':"\\|,.<>\/?]+/; // special char without "+" and "-"
    return re.test(string);
};
exports.hasRepetitiveNumberMorethanAllowedNumber = (string, allowedRepetitiveNumberCount) => {
    const re = new RegExp(`(.)(\\1{${allowedRepetitiveNumberCount},})`);
    return re.test(string);
};
exports.hasSequentialNumberMorethanAllowedNumber = (string, allowedSequentialNumberCount) => {
    const patterns = ['01234567890', '09876543210'];
    const findSequence = (pattern) => {
        const number = string.split('');
        let commons = [];
        for (const num of number) {
            const common = commons.join('').concat(num);
            if (pattern.includes(common)) {
                commons.push(num);
                if (commons.length > allowedSequentialNumberCount)
                    return true;
            }
            else {
                commons = [];
            }
        }
        return commons.length > allowedSequentialNumberCount;
    };
    return findSequence(patterns[0]) || findSequence(patterns[1]);
};
exports.isShorterThan = (string, length) => {
    return string && string.length < length;
};
exports.isLongerThan = (string, length) => {
    return string && string.length > length;
};
exports.maskEmail = (email) => {
    const wrongEmail = 'wrong email';
    if (!Boolean(email) || email.indexOf('@') === -1) {
        return wrongEmail;
    }
    const [name, domain] = email.split('@');
    if (!Boolean(name) || !Boolean(domain)) {
        return wrongEmail;
    }
    const prefixFirst = name[0];
    const prefixLast = name.length > 1 ? name[name.length - 1] : '';
    const maskedPrefix = `${prefixFirst}****${prefixLast}`;
    return `${maskedPrefix}@${domain}`;
};
exports.transformSecondsToWords = (seconds) => {
    const rawSeconds = Number(seconds);
    const numHours = Math.floor(rawSeconds / 3600);
    const numMinutes = Math.floor((rawSeconds % 3600) / 60);
    const numSeconds = Math.floor((rawSeconds % 3600) % 60);
    // eslint-disable-next-line eqeqeq
    const hDisplay = numHours > 0 ? numHours + (numHours == 1 ? ' hour ' : ' hours ') : '';
    // eslint-disable-next-line eqeqeq
    const mDisplay = numMinutes > 0 ? numMinutes + (numMinutes == 1 ? ' minute ' : ' minutes ') : '';
    // eslint-disable-next-line eqeqeq
    const sDisplay = numSeconds > 0 ? numSeconds + (numSeconds == 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay + sDisplay;
};
exports.replaceAutoSlashDate = (dateToFormat) => dateToFormat
    .replace(/^(\d\d)(\d)$/g, '$1/$2')
    .replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
    .replace(/[^\d\/]/g, ''); // eslint-disable-line no-useless-escape
exports.replaceStringToNumber = (value) => {
    return Number(value === null || value === void 0 ? void 0 : value.replace(/^\D+/g, ''));
};
exports.replaceFileType = (fileName) => {
    return fileName.replace(/\.[^/.]+$/, '');
};
exports.formatToBase64 = (type) => {
    return Buffer.from(type).toString('base64');
};
exports.objectToQueryString = (object) => {
    var _a, _b;
    return ((_a = Object === null || Object === void 0 ? void 0 : Object.keys(object)) === null || _a === void 0 ? void 0 : _a.length) ? (_b = Object.entries(object)) === null || _b === void 0 ? void 0 : _b.reduce((acc, item) => [...acc, `${item[0]}=${item[1]}`], []).join('&') : '';
};
exports.hasThisWord = (text, word) => {
    const re = new RegExp(`${word}`, 'i');
    return text.match(re) !== null;
};
exports.replaceHyphenWithSplitAndShift = (text) => {
    var _a, _b;
    return (_b = (_a = text === null || text === void 0 ? void 0 : text.replace('-', '')) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b.shift();
};
exports.replaceSlashAndDashes = (dirtyString) => {
    const newString = dirtyString.replace(/[\s\/\-]/g, '');
    return newString || '';
};
exports.stripHtml = (dirtyString) => {
    const doc = dirtyString.replace(/(<([^>]+)>)/gi, '');
    return doc || '';
};
exports.isValidHtml = (dirtyString) => {
    const doc = new DOMParser().parseFromString(dirtyString, 'text/html');
    const errorNode = doc.querySelector('parsererror');
    if (errorNode) {
        // parsing failed
        return false;
    }
    {
        const bodyNode = doc.querySelector('body');
        if (dirtyString !== bodyNode.innerHTML) {
            return false;
        }
    }
    return true;
};
exports.getNumberStr = (number, currency) => `${currency.sign}${(Number(number) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})}`;
//# sourceMappingURL=StringHelpers.js.map